const trackingUtils = require('od-modules/utils/tracking.utils');
const UiGoogleMap = require('od-modules/helpers/map/ui/single_marker');
const parser = require('od-modules/parsers/accommodation_details');
const {trackFullScreenChange} = require('od-modules/helpers/map/full_screen');

var DELAY = {
    slider: 5000,
    bgd_in: 300,
    bgd_out: 100,
};
const ROOMSPANEL = 'roomInfo';


function closeHints() {
    Odigeo.UIElements.hint.hidePageHints(
        Odigeo.History.getPageNameFromFragment()
    );

    return this;
}

function toggle(hasOpen) {
    this.$el.toggleClass('open', hasOpen)
        .closest('.accommodation_details_super_container')
        .toggleClass('details-opened', hasOpen);

    Odigeo.trigger(getEvent.call(this, 'setPreselectedDetailsStatus'), {
        hasOpen: hasOpen,
        $boxDetail: this.$el,
    });

    if (this.settings.isLightbox) {
        this.lightBox.toggle(true);
    }

    return this;
}

function panelManager(panel) {
    if (this.handlerUi) {
        var panelTarget = this.handlerUi.getPanel(panel || this.defaultTab);
        Odigeo.trigger(getEvent.call(this, 'panelOpen'), panelTarget, this.getElementTop());
        panelActions.call(this, panelTarget);
    }
}

function activateTab(panel) {
    if (this.handlerUi) {
        this.handlerUi.setActiveTab(panel);
        this.handlerUi.togglePanelWithName(panel);
    }
}

function panelActions(panel) {
    if (panel.indexOf('map') > -1) {
        closeGeneralMap.call(this);
        if (this.options.hasStaticMap) {
            resetStaticMapViewElement.call(this);
            updateStaticMap.call(this, this.model.getCoordinates());
        } else {
            resetMap.call(this);
        }
    } else {
        removeIntervalSliderImage.call(this);
    }
    return this;
}

function resetMap() {
    var coordinates = this.model.getCoordinates();
    var mapView = this.$cachedSelectors.map.get(0);
    const onMapUpdate = () => {
        this.uiMap.refreshMap();
        if (this.options.isFullScreen) {
            this.uiMap.onFullScreen(trackFullScreenChange);
        }
    };

    if (this.uiMap.hasMapElement(mapView)) {
        this.uiMap.refreshMap();
    } else {
        this.uiMap.update({
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
            mapView: mapView,
        }).then(onMapUpdate.bind(this));
    }
}

function resetStaticMapViewElement() {
    Odigeo.trigger(`${this.widget.id}:updateStaticMapViewElement`, this.$el);
}

function updateStaticMap(coordinates) {
    Odigeo.trigger(`${this.widget.id}:updateStaticMap`, coordinates);
}

function closeGeneralMap() {
    if (/_preselected_details_container$/.test(this.settings.target)) {
        Odigeo.trigger(getEvent.call(this, 'closeGeneralMap'));
    }
}

function unbindImgs() {
    Odigeo.UIElements.fade.unbind(this.$cachedSelectors.fadeSliderImage);
    this.$cachedSelectors.thumbnail.off('error load');
    this.$cachedSelectors.sliderImage.off('error load');
    this.$cachedSelectors.hoverImgElement.off('error load');

    return this;
}

function bindGalleryImgs() {
    var imgSize = this.model.getImagesLength();
    var errors = [];
    var checkImgLoads = Odigeo._.bind(function() {
        if (--imgSize === 0) {
            this.model.deleteImgs(errors);
            changeSlider.call(this, this.sliderIndex);
        }
    }, this);

    this.$cachedSelectors.thumbnail.on('error load', function(ev) {
        if (ev.type === 'error') {
            errors.push(parseInt($(ev.target).data('imgIndex'), 10));
        }
        checkImgLoads();
    });

    return this;
}

function changeSlider(index) {
    var $slider = this.$cachedSelectors.fullscreenSliderImage;
    var animationDelay = $.fx.muted ? {} : DELAY;
    var imageUrl = 'url(' + this.model.getImage(index).url + ')';

    $slider.removeClass('loaded')
        .delay(animationDelay.bgd_out)
        .queue(function() {
            $slider.attr('data-img-index', index)
                .data('imgIndex', index)
                .css('background-image', imageUrl)
                .dequeue();
        })
        .delay(animationDelay.bgd_in)
        .queue(function() {
            $slider.addClass('loaded').dequeue();
        });
}

function removeIntervalSliderImage() {
    if (!Odigeo._.isNull(this.intervalReference)) {
        clearInterval(this.intervalReference);
    }

    return this;
}

function toggleNativeUserEvents(ev) {
    if (Odigeo._.isObject(ev) && !Odigeo._.isUndefined(ev.originalEvent)) {
        this.trackEvent('close_hotel_information');
    }
}

function toggleFromResultsPage(ev) {
    if (Odigeo._.isObject(ev) && ev.page === Odigeo.History.getPageNameFromFragment()) {
        Odigeo.trigger(getEvent.call(this, 'closeHints'));
    }
}

function blurCancellationPolicyPopups() {
    this.$cachedSelectors.cancellationPoliciesPopups.removeClass('open').addClass('odf-hidden');
    return this;
}

function getRoomInfo(key) {
    loadRoomSelection.call(this, key);
}

function loadRoomSelection(key) {
    if (this.model.get('hasRoomSelection')) {
        Odigeo.trigger(getEvent.call(this, 'loadRoomSelection'), {
            key,
            pricePerceptionTrackingData: this.model.get('pricePerceptionTrackingData'),
        });
    }
}

function setLoading() {
    this.setTemplate(this.$el, 'loading');
    this.open({silent: true});

    return this;
}

function renderGallery() {
    unbindImgs.call(this);

    if (!this.model.getImagesLength()) {
        if (this.$cachedSelectors.tabGallery.length !== 0) {
            this.$cachedSelectors.gallery.addClass('odf-hidden');
            this.$cachedSelectors.tabGallery.remove();
        }
        if (this.settings.panel === 'gallery') {
            var nextTab = getNextTab.call(this);

            panelManager.call(this, nextTab);
            activateTab.call(this, getNextTab.call(this), nextTab);
        }
    }

    return this;
}

function detailsLoadFailed(error) {
    switch (error.status) {
        case 200:
            if (Odigeo.SessionScope.flow === 'mobile') {
                Odigeo.trigger('sessionExpiredError:open', 'alert', true);
            } else {
                Odigeo.UIElements.showSessionExpiredError('alert', true);
            }
            break;
        default:
            Odigeo.UIElements.showBrokenFlowError('alert', true);
            break;
    }
    this.close();
}

function bindEvents() {
    if (this.widget.id !== 'xsell-accommodation-details') {
        Odigeo.on('ui-hint:show', Odigeo._.bind(this.close, this));
    }
    this.listenTo(this.model, 'loadDetails', this.refresh);
    this.listenTo(this.model, 'failLoad', Odigeo._.bind(detailsLoadFailed, this));
    this.listenTo(this.model, 'fetchDetails', Odigeo._.bind(setLoading, this));
    this.listenTo(this.model, 'remove:img', Odigeo._.bind(renderGallery, this));
    this.listenTo(Odigeo.Events.fake, 'fake:blur', function() {
        if (this.isOpen() && !this.widget.isInProcess()) {
            this.close();
        }
    });

    return this;
}

function getEvent(event) {
    return this.widget.id + ':' + event;
}

function getNextTab() {
    var nextTab = this.$cachedSelectors.tabs.not('[data-panel="gallery"]').first().data('panel');

    return nextTab;
}

// Trigger the hover events on touch instead of cursor enter and cursor out
function handleTouchables() {
    if (Odigeo.Device.navigator.isTouchable()) {
        this.events['touchstart .gallery_thumbnail'] = this.events['mouseenter .gallery_thumbnail'];
        this.events['touchend .gallery_thumbnail'] = this.events['mouseout .gallery_thumbnail'];
        delete this.events['mouseenter .gallery_thumbnail'];
        delete this.events['mouseout .gallery_thumbnail'];
    }
}

function activePanel() {
    if (this.handlerUi) {
        this.handlerUi.setActivePanelIndex();
    }
}

function showOrHideChooseRoomButton(targetPanel) {
    if (targetPanel === ROOMSPANEL) {
        this.$el.find('.choose_room_button').toggleClass('odf-hidden');
    } else {
        this.$el.find('.choose_room_button').removeClass('odf-hidden');
    }
}

module.exports = Odigeo.View.extend({
    events: {
        'tap': 'onTapInElement',
        'change .accommodation_show_hotelpopup': 'onChangeTab',
        'tap .accommodation_close_hotelpopup': 'close',
        'tap .gallery_thumbnail': 'trackEventImage',
        'tap .fullscreen_slider_image': 'trackEventImage',
        'tap .fullscreen_gallery_thumbnail:not(.selected)': 'toggleSliderImage',
        'tap .gallery_arrow': 'toggleSliderImageFromArrow',
        'tap .choose_room_button': 'switchToChooseRoomTab',
        'mousedown @staticMap': 'onClickShowDynamicMap',
    },

    selectors: {
        tabPanels: '.tab_panel',
        tabs: '.accommodation_show_hotelpopup',
        tabGallery: '.accommodation_show_hotelpopup[data-panel="gallery"]',
        map: '.panel_map',
        staticMap: '.static_map_accommodation_results',
        gallery: '.panel_gallery',
        hoverImg: '.gallery_hover_img',
        hoverImgElement: '.gallery_hover_img img',
        thumbnail: '.gallery_thumbnail',
        sliderImage: '.slider_image',
        fullscreenSliderImage: '.fullscreen_slider_image',
        fadeSliderImage: '.fade_slider_image',
        fullScreenGallery: '.gallery_wrapper',
        panelSelector: '.panel_container_accommodation_details',
        accommodationTabs: '.accommodation_details_tabs',
        cancellationPoliciesPopups: '.cancellation_policy_info',
        counterSelected: '.counter_selected',
    },

    defaults: {
        panel: null,
        target: null,
        key: null,
    },

    templates: {},
    settings: {},
    sliderIndex: 0,
    intervalReference: null,
    roomSelectionTestPartition: null,
    handlerUi: null,
    defaultTab: null,
    enhanceMap: null,
    lightbox: null,

    init: function() {
        handleTouchables.call(this);
        this.options = Odigeo.Utils.parseOptions(this.widget.options);
        this.trackEvent = Odigeo._.bind(trackingUtils.trackEvent, trackingUtils, this.options.trackingAction);
        this.setElement();
        this.uiMap = new UiGoogleMap({
            hasIconMarkerBrand: this.options.hasIconMarkerBrand,
            draggable: !!this.options.isDraggable,
            disableDoubleClickZoom: this.options.isDisabledDoubleClickZoom,
            fullscreenControl: !!this.options.isFullScreen,
        });
        bindEvents.call(this);
    },

    beforeInsertTemplate: function() {
        return Odigeo._.extend(
            parser.getAccommodationDetailsData(this.model, {
                roomSelectionTestPartition: this.roomSelectionTestPartition,
                isLightbox: this.settings.isLightbox,
            }), {
                images: this.model.getImages(),
                sliderIndex: this.sliderIndex,
            });
    },

    render: function() {
        if (Odigeo._.isElement(this.el)) {
            this.setTemplate(this.$el, this.options.mainDetailsTemplate);
        }
        return this;
    },

    update: function(options) {
        this.settings = Odigeo._.defaults({}, options, this.defaults);
        unbindImgs.call(this);
        this.setElement($('#' + this.settings.target));

        if (this.settings.target === 'map_details_container') {
            this.$el.data('nights', options.nights);
        }
        return this;
    },

    updateTarget: function(options) {
        if (!this.isCurrentTarget(options.target)) {
            this.close();
            this.createLightBox(options);
        }
    },

    postRender: function() {
        if (Odigeo._.isElement(this.el)) {
            var specificOptions = {
                allowEmptySelection: false,
                panelSelector: this.el,
                defaultTab: this.defaultTab,
            };
            this.handlerUi = Odigeo.UIElements.enhanceTabs(this.selectors.accommodationTabs, specificOptions);
            this.updateDomSelectorsToCache();
            renderGallery.call(this);
            bindGalleryImgs.call(this);
            this.open({silent: false});
            panelManager.call(this);
            getRoomInfo.call(this, this.model.get('key'));
            this.configureIPLightBoxRender();
        }
    },

    configureIPLightBoxRender() {
        if (this.settings.isIPLightBox) {
            showOrHideChooseRoomButton.call(this, this.settings.panel);
        }
    },

    onTapInElement: function(evt) {
        evt.stopPropagation();
        closeHints.call(this);

        return this;
    },

    onChangeTab: function(evt) {
        var $tab = $(evt.currentTarget);

        this.trackEvent($tab.data('label'));
        panelManager.call(this, $tab.data('panel'));
        Odigeo.trigger(getEvent.call(this, 'toggleLinkDetailsStatus'), $tab.data('panel'));
        evt.stopPropagation();
        if (this.settings.isIPLightBox) {
            showOrHideChooseRoomButton.call(this, $tab.data('panel'));
        }
    },

    switchToChooseRoomTab: function() {
        this.handlerUi.hideActivePanel();
        showOrHideChooseRoomButton.call(this, ROOMSPANEL);
        activateTab.call(this, ROOMSPANEL);
    },

    trackEventImage: function(evt) {
        this.trackEvent($(evt.target).data('imgTracking'));
    },

    setRoomSelectionTestPartition: function(partitionValue) {
        this.roomSelectionTestPartition = partitionValue;
    },

    open: function(options) {
        toggle.call(this, true);
        closeHints.call(this);

        if (Odigeo._.isObject(options) && !options.silent) {
            Odigeo.trigger(getEvent.call(this, 'open'), this.settings, this.getElementTop());
        }

        return this;
    },

    hasToClose: function(ev) {
        return (Odigeo._.isUndefined(ev) || Odigeo._.isUndefined(ev.element)) || $(ev.element).attr('data-has-to-close-container') === 'true';
    },

    closePanel: function(args) {
        activePanel.call(this);
        Odigeo.trigger(getEvent.call(this, 'toggleLinkDetailsStatus'));
        blurCancellationPolicyPopups.call(this);
        toggle.call(this, false);
        removeIntervalSliderImage.call(this);
        toggleNativeUserEvents.apply(this, args);
        toggleFromResultsPage.apply(this, args);
    },

    close: function() {
        if (!this.settings.isLightbox && this.hasToClose.apply(this, arguments)) {
            this.closePanel(arguments);
        } else if (this.settings.isLightbox) {
            this.lightBox.toggle(false);
        }

        return this;
    },

    isOpen: function() {
        return this.$el.hasClass('open');
    },

    isCurrentTarget: function(target) {
        return this.settings.target === target;
    },

    getElementTop: function() {
        return this.$el.offset().top - (Odigeo.Device.getScreenHeight() / 2);
    },

    getRoomContainer: function() {
        return this.$el.find('.panel_roomInfo');
    },

    createLightBox: function(options) {
        if (options.isLightbox) {
            this.lightBox = new Odigeo.UIElements.Lightbox($('#' + options.page + '_accommodation_details_lightbox'));
        }
    },

    toggleSliderImage: function(evt) {
        var $selectedImage = $(evt.target);
        this.updateSliderImage($selectedImage);
    },

    updateSliderImage: function($selectedImage) {
        this.$cachedSelectors.thumbnail
            .removeClass('selected')
            .filter($selectedImage).addClass('selected');
        changeSlider.call(this, $selectedImage.data('imgIndex'));
        this.updateCounterText($selectedImage);
    },

    toggleSliderImageFromArrow: function(evt) {
        var $selectedArrow = $(evt.target);
        var imageIndexIncrement = $selectedArrow.hasClass('next') ? 1 : -1;
        var $currentImage = this.$el.find(this.selectors.thumbnail + '.selected');
        var currentImageIndex = parseInt($currentImage.data('imgIndex'), 10);
        var currentImageIndexPlusIncrement = currentImageIndex + imageIndexIncrement;
        var calculatedOrLastIndex = currentImageIndexPlusIncrement < 0 ? this.model.getImagesLength() - 1 : currentImageIndexPlusIncrement;
        var newImageIndex = currentImageIndexPlusIncrement >= this.model.getImagesLength() ? 0 : calculatedOrLastIndex;
        var $newImage = this.$el.find(this.selectors.thumbnail + '[data-img-index=' + newImageIndex + ']');

        this.trackEvent($selectedArrow.data('arrowTracking'));
        this.updateSliderImage($newImage);
    },

    updateCounterText: function($newImage) {
        var newImageIndex = 1 + parseInt($newImage.data('imgIndex'), 10);
        this.$cachedSelectors.counterSelected.text(newImageIndex);
    },

    updateDomSelectorsToCache: function() {
        Odigeo._.each(this.selectors, function(sel, key) {
            this.removeSelectorFromCache(key);
            this.addSelectorToCache(key, this.$el.find(sel));
        }, this);
    },

    onClickShowDynamicMap() {
        resetMap.call(this);
        this.$cachedSelectors.staticMap.toggleClass('odf-hidden', true);
        this.$cachedSelectors.map.toggleClass('odf-hidden', false);
    },
});
